import { proximaNova } from '../styles/fonts';
import type { ThemeConfig } from './types';
import { semanticColors } from '../styles/semanticColors';
import radius from '../styles/radius';
import shadow from '../styles/shadow';

const hbuiTheme: ThemeConfig = {
    fonts: {
        body: proximaNova,
        heading: proximaNova,
        display: proximaNova
    },
    colors: semanticColors,
    radius,
    shadow
};

export default hbuiTheme;
